import { Injectable } from '@angular/core';

@Injectable()
export class PubSubService {
  events: any;

  constructor() {
    this.events = {};
  }

  subscription(eventName, func) {
    return {
      subscribe: () => {
        if (this.events[eventName]) {
          this.events[eventName].push(func);
        } else {
          this.events[eventName] = [func];
        }
      },

      unsubscribe: () => {
        if (this.events[eventName]) {
          this.events[eventName] = this.events[eventName].filter(subscriber => subscriber !== func);
        }
      }
    };
  }

  publish(eventName, ...args) {
    const funcs = this.events[eventName];
    if (Array.isArray(funcs)) {
      funcs.forEach(func => {
        func.apply(null, args);
      });
    }
  }
}
